import Link from 'next/link';

import Container from '@/components/@base/container';
import { TEXT_TYPE } from '@/components/@base/typography/text/type';
import XImage from '@/components/@base/x-image';
import Props from '@/components/app/archive/components/info/category-and-tag/categories/type';
import IconTextCombo from '@/components/shared/components/icon-text-combo';

export default function Categories({ tags }: Props) {
  return (
    <Container
      center
      className="no-scrollbar justify-start gap-2.5 overflow-x-auto overflow-y-visible px-4 py-4 md:justify-end md:gap-5 md:overflow-x-visible md:px-0 md:py-5"
    >
      {tags?.map(({ title, icon, id, slug }) => (
        <Link prefetch={false}
              key={id}
              href={`/web/tag/${slug}`}
              className="group w-full md:aspect-square md:max-w-[140px]"
        >
          <IconTextCombo
            key={id}
            title={title}
            textType={TEXT_TYPE.P}
            textClassName="max-w-[200px] text-[#76767C] text-[13px] font-bold truncate md:max-w-[90%] group-hover:text-[#ff9606] transition duration-300"
            wrapperClassName="cursor-pointer flex md:flex-col justify-center items-center gap-2 p-2 bg-[#FFFFFF] rounded-md shadow-[0px_10px_25px_-5px_#878F9B17] md:shadow-[0px_10px_25px_-5px_#878F9B2B] w-full h-full"
            Icon={
              <XImage
                src={icon.publicLink}
                alt={icon.description}
                width={36}
                height={36}
                className="min-w-[36px] rounded-md md:w-[48px]"
              />
            }
          />
        </Link>
      ))}
    </Container>
  );
}
